function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { generateUniqueId } from 'seagull/utils/generateUniqueId';
import { DraftStatusType, serviceModel } from "../../models";
export const defaultCoverLetterNewClient = "We've created an agreement in Anchor, a billing platform that we use to automate the payment process so both of us can save time and effort.\n\nIt includes a detailed description of the services we agreed on, the price, and the billing terms.\n\nPlease review and approve the agreement.";
export function contactHasAgreement(contact, agreements, proposals) {
  if (!(contact !== null && contact !== void 0 && contact.customerId())) return false;
  const hasContact = r => !r.isSample && r.customer.id === contact.customerId();
  return !!agreements && agreements.some(hasContact) || !!proposals && proposals.some(hasContact);
}
export function fromAgreementStudioCommon(_ref) {
  var _data$legalTermsOld, _data$legalTermsDocum, _data$serviceBundles;
  let {
    data,
    title,
    agreementName,
    effectiveDate
  } = _ref;
  return {
    id: generateUniqueId('proposal-template'),
    title,
    agreementName,
    effectiveDate,
    extraClause: data.extraClause,
    requirePaymentMethod: data.requirePaymentMethod,
    allowManualPayments: data.allowManualPayments,
    customNotificationText: data.customNotificationText,
    isExistingCustomer: data.isExistingCustomer,
    netTerms: data.netTerms,
    coverLetter: data.coverLetter,
    feeControls: {
      coverCreditCardFees: data.coverCreditCardFees,
      coverDirectDebitFees: false
    },
    legalTerms: (_data$legalTermsOld = data.legalTermsOld) !== null && _data$legalTermsOld !== void 0 ? _data$legalTermsOld : null,
    legalTermsDocuments: (_data$legalTermsDocum = data.legalTermsDocuments) !== null && _data$legalTermsDocum !== void 0 && _data$legalTermsDocum.length && data.legalTermsDocuments.length > 0 ? data.legalTermsDocuments : null,
    services: data.services.map(serviceModel.toDTO),
    serviceBundles: (_data$serviceBundles = data.serviceBundles) !== null && _data$serviceBundles !== void 0 && _data$serviceBundles.bundles.length ? {
      bundles: data.serviceBundles.bundles.map(b => _objectSpread(_objectSpread({}, b), {}, {
        services: b.services.map(serviceModel.toDTO)
      }))
    } : undefined,
    amendmentsApprovalMethod: data.amendmentsApprovalMethod,
    invoicesApprovalMethod: data.invoicesApprovalMethod,
    requestAccountantAccess: data.requestAccountantAccess,
    introVideo: data.introVideo,
    expirationDate: data.expirationDate,
    status: {
      type: DraftStatusType.Active
    }
  };
}